import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'creditCoverage',
    templateUrl: 'credit-coverage.component.html'
})

export class CreditCoverage implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }
}